var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.074,
    height: 233.074,
    viewBox: "0 0 186.074 233.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26232",
    "data-name": "Group 26232",
    transform: "translate(-409 -374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-file",
    transform: "translate(409 374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143709",
    "data-name": "Path 143709",
    d: "M3.5,96.536a93.03,93.03,0,1,1,20.163,57.843A93.026,93.026,0,0,1,3.5,96.536Zm10.8,73.579a4.465,4.465,0,1,0-5.931,2.233A4.477,4.477,0,0,0,14.3,170.115Zm6.575,8.753a2.842,2.842,0,1,0-3.775,1.421A2.849,2.849,0,0,0,20.876,178.868Zm157.932-163.5a4.465,4.465,0,1,0-6.319.481A4.477,4.477,0,0,0,178.809,15.364Zm3.857,10.246a2.842,2.842,0,1,0-4.022.306A2.849,2.849,0,0,0,182.665,25.61ZM19.915,24.185a4.465,4.465,0,1,0-6.319.481A4.477,4.477,0,0,0,19.915,24.185Z",
    transform: "translate(-3.5 -3.499)",
    fill: "#38264d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143710",
    "data-name": "Path 143710",
    d: "M161.691,49.581V175.661a13.9,13.9,0,0,1-13.912,13.912H33.357a13.9,13.9,0,0,1-13.912-13.912V17.411A13.9,13.9,0,0,1,33.357,3.5H112.73a14.785,14.785,0,0,1,2.137.16,13.873,13.873,0,0,1,7.254,3.5l35.063,32.17a13.8,13.8,0,0,1,4.143,7.138A13.1,13.1,0,0,1,161.691,49.581Z",
    transform: "translate(3.734 -3.499)",
    fill: "#5c4e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143711",
    "data-name": "Path 143711",
    d: "M131.546,46.421H91.82a6.735,6.735,0,0,1-6.735-6.735V3.609a13.873,13.873,0,0,1,7.254,3.5L127.4,39.283A13.8,13.8,0,0,1,131.546,46.421Z",
    transform: "translate(33.516 -3.449)",
    fill: "#706084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143712",
    "data-name": "Path 143712",
    d: "M86.795,19.536V14.46a.524.524,0,0,0-.524-.524H37.305a.524.524,0,0,0-.524.524v5.077a.524.524,0,0,0,.524.524H86.27A.524.524,0,0,0,86.795,19.536ZM66.766,34.057V28.98a.524.524,0,0,0-.524-.524H37.305a.524.524,0,0,0-.524.524v5.077a.524.524,0,0,0,.524.524H66.242A.524.524,0,0,0,66.766,34.057ZM98.1,158.4v4.091a1.055,1.055,0,0,1-1.055,1.055h-59.2a1.055,1.055,0,0,1-1.055-1.055V158.4a1.055,1.055,0,0,1,1.055-1.055h59.2A1.055,1.055,0,0,1,98.1,158.4Z",
    transform: "translate(11.6 1.236)",
    fill: "#e0e4ed",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26231",
    "data-name": "Group 26231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143713",
    "data-name": "Path 143713",
    d: "M52.1,50.642a45.5,45.5,0,1,0,64.351,0A45.5,45.5,0,0,0,52.1,50.642Zm55.418,55.418a32.87,32.87,0,1,1,0-46.485A32.866,32.866,0,0,1,107.517,106.06Z",
    transform: "translate(12.502 11.843)",
    fill: "#38264d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143714",
    "data-name": "Path 143714",
    d: "M107.6,97.532,99,106.138,89.04,96.194a44.752,44.752,0,0,0,8.62-8.606Z",
    transform: "translate(35.311 34.653)",
    fill: "#38264d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143715",
    "data-name": "Path 143715",
    d: "M111.725,93.746l19.261,19.261a11.683,11.683,0,0,1,0,16.523h0a11.683,11.683,0,0,1-16.523,0L95.2,110.268a3.518,3.518,0,0,1,0-4.975L106.75,93.746A3.518,3.518,0,0,1,111.725,93.746Z",
    transform: "translate(37.639 36.979)",
    fill: "#38264d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143716",
    "data-name": "Path 143716",
    d: "M79.66,78.819a1.453,1.453,0,0,1-1.454-1.454,2.437,2.437,0,0,0-4.874,0,1.454,1.454,0,0,1-2.907,0c0-7.073,10.688-7.065,10.688,0A1.453,1.453,0,0,1,79.66,78.819ZM92.045,66.47H86.011a1.454,1.454,0,1,1,0-2.907h6.033a1.454,1.454,0,1,1,0,2.907Zm-26.519,0H59.494a1.454,1.454,0,1,1,0-2.907h6.032a1.454,1.454,0,1,1,0,2.907Z",
    transform: "translate(21.245 23.752)",
    fill: "#38264d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143717",
    "data-name": "Path 143717",
    d: "M97.77,41.716a2.15,2.15,0,1,1-2.145-2.145A2.146,2.146,0,0,1,97.77,41.716Zm7.451,0a2.15,2.15,0,1,1-2.145-2.145A2.146,2.146,0,0,1,105.221,41.716Zm7.451,0a2.15,2.15,0,1,1-2.145-2.145A2.146,2.146,0,0,1,112.672,41.716Z",
    transform: "translate(37.32 12.867)",
    fill: "#989fb0",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("text", {
    id: "No_data_found_",
    "data-name": "No data found!",
    transform: "translate(441 601.074)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "No data found!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.31d5338437d3498f1d291cb2a9b7c087.svg";
export { ForwardRef as ReactComponent };